import { useCallback, useMemo } from 'react'

export const useTimeConverter = (
  value: number | undefined,
  onChange: (value: number | undefined) => void,
) => {
  // Convert seconds to Date object for TimePicker
  // Return null for undefined, -1, or negative values to indicate no time selected
  const convertedValue = useMemo(() => {
    if (value === undefined || value === -1 || value < 0) return null

    const hours = Math.floor(value / 3600)
    const minutes = Math.floor((value % 3600) / 60)

    // Use a fixed date (today at midnight) to avoid timezone issues
    const date = new Date()
    date.setHours(0, 0, 0, 0)
    date.setHours(hours, minutes, 0, 0)

    return date
  }, [value])

  // Handle onChange to convert Date -> seconds (hours and minutes only)
  const handleChange = useCallback(
    (newValue: Date | null) => {
      // Return -1 for null or invalid time
      if (!newValue) {
        onChange(-1)
        return
      }

      const hours = newValue.getHours()
      const minutes = newValue.getMinutes()
      const totalSeconds = hours * 3600 + minutes * 60

      onChange(totalSeconds)
    },
    [onChange],
  )

  return {
    convertedValue,
    handleChange,
  }
}
